import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Blueprint } from '../../../models/blueprint.model';
import { BlueprintItem } from '../../../models/blueprint-item.model';
import { SettingsService } from '../../settings-page/settings-service/settings.service';

@Component({
  selector: 'app-blueprint-item-viewer',
  imports: [CommonModule],
  templateUrl: './blueprint-item-viewer.component.html',
  styleUrl: './blueprint-item-viewer.component.scss',
})
export class BlueprintItemViewerComponent {
  @Input() blueprintItem!: BlueprintItem;
  @Input() blueprint!: Blueprint; // Required when using blueprintItem
  @Input() blueprintMap: Map<string, Blueprint> = new Map();

  settingsService = inject(SettingsService);
  tradeStudyToolFeaturesEnabled$ =
    this.settingsService.isTradeStudyToolFeaturesEnabled$();
  consumablesEnabled$ = this.settingsService.isConsumablesEnabled$();

  getReferencedBlueprint(
    blueprintId: string | undefined | null,
  ): Blueprint | null {
    if (!blueprintId) {
      return null;
    }
    const blueprint = this.blueprintMap.get(blueprintId);
    return blueprint || null;
  }

  /**
   * Get children of a BlueprintItem, sorted by sibling_order
   */
  getChildren(parentId: string | number | undefined): BlueprintItem[] {
    if (!this.blueprint?.items || this.blueprint.items.length === 0) {
      return [];
    }
    // Convert parentId to string for comparison (backend returns parent_blueprint_item_id as string)
    const parentIdStr = parentId !== undefined ? String(parentId) : null;
    return this.blueprint.items
      .filter((item) => {
        // Convert parent_blueprint_item_id to string for comparison
        const itemParentId =
          item.parent_blueprint_item_id !== null &&
          item.parent_blueprint_item_id !== undefined
            ? String(item.parent_blueprint_item_id)
            : null;
        return itemParentId === parentIdStr;
      })
      .sort((a, b) => a.sibling_order - b.sibling_order);
  }

  /**
   * Get root items (items with no parent) from a blueprint, sorted by sibling_order
   */
  getRootItems(blueprint: Blueprint): BlueprintItem[] {
    if (!blueprint.items || blueprint.items.length === 0) {
      return [];
    }
    return blueprint.items
      .filter((item) => item.parent_blueprint_item_id === null)
      .sort((a, b) => a.sibling_order - b.sibling_order);
  }

  getCapexLinkedCount(item: BlueprintItem): number {
    const ids = item.capex_equipment_ids ?? [];
    if (ids.length > 0) {
      return ids.length;
    }
    return item.capex_equipment?.length ?? 0;
  }

  getConsumableCount(item: BlueprintItem): number {
    return item.consumables?.length ?? 0;
  }
}
